// extracted by mini-css-extract-plugin
export default {"dropdown":"WorkshopTypeDropdown_dropdown__XIb2a"};